module.exports = __webpack_public_path__ + "static/media/sansiro-massaguacu-embreve-03.a9e42029.jpg";